import React from "react"
import CustomBreadCrumb from "../features/DataMetadata/CustomBreadCrumb"

export function BreadCrumbWrapper(props: any) {
  return (
    <div>
      <CustomBreadCrumb />
      {props.children}
    </div>
  )
}
